import { gql } from 'graphql-request';


export const SITE_NOTIFICATION_FRAGMENT = gql`
    fragment SiteNotificationFields on SiteNotification {
        id
        creationDate
        level
        type
        state
        properties
    }
`